import axios from "axios";

const BASE = process.env.REACT_APP_HAMTA_API;
const admin = axios.create({ baseURL: BASE, timeout: 25000 });

admin.interceptors.request.use((cfg) => {
  const tok = localStorage.getItem("ha_admin_token");
  if (tok) cfg.headers.authorization = `Bearer ${tok}`;
  return cfg;
});

// On expired/invalid session (401), sign out and let the UI redirect to login.
admin.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error?.response?.status === 401 && !/\/auth\/(session|login)/.test(error?.config?.url || "")) {
      localStorage.removeItem("ha_admin_token");
      localStorage.removeItem("ha_admin_user");
      window.dispatchEvent(new CustomEvent("ha-admin-signout"));
    }
    return Promise.reject(error);
  }
);

export const adminApi = {
  login: (email, password) => admin.post("/auth/login", { email, password }).then((r) => r.data),
  session: (session_id) => admin.post("/auth/session", { session_id }).then((r) => r.data),
  me: () => admin.get("/auth/me").then((r) => r.data),
  stats: () => admin.get("/admin/stats").then((r) => r.data),

  orders: (status) => admin.get("/admin/orders", { params: status ? { status } : {} }).then((r) => r.data),
  approve: (id) => admin.post(`/admin/orders/${id}/approve`).then((r) => r.data),
  reject: (id) => admin.post(`/admin/orders/${id}/reject`).then((r) => r.data),
  refund: (id) => admin.post(`/admin/orders/${id}/refund`).then((r) => r.data),
  deleteOrder: (id) => admin.delete(`/admin/orders/${id}`).then((r) => r.data),
  setStatus: (id, status) => admin.post(`/orders/${id}/status`, { status }).then((r) => r.data),
  setAmount: (id, amount) => admin.patch(`/orders/${id}/amount`, { amount }).then((r) => r.data),

  createStore: (body) => admin.post("/admin/stores", body).then((r) => r.data),
  deleteStore: (body) => admin.post("/admin/stores/delete", body).then((r) => r.data),

  createProduct: (body) => admin.post("/admin/store-products", body).then((r) => r.data),
  updateProduct: (id, body) => admin.patch(`/admin/store-products/${id}`, body).then((r) => r.data),
  deleteProduct: (body) => admin.post("/admin/store-products/delete", body).then((r) => r.data),
  sectionProducts: (storeId) => admin.get("/store-products", { params: { store_id: storeId, limit: 5000 } }).then((r) => r.data),

  upload: (file) => {
    const fd = new FormData();
    fd.append("file", file);
    return admin.post("/upload", fd).then((r) => r.data);
  },

  threads: () => admin.get("/chat/threads").then((r) => r.data),
  messages: (params) => admin.get("/chat/messages", { params }).then((r) => r.data),
  reply: (body) => admin.post("/chat/messages", body).then((r) => r.data),
};

export default adminApi;
